import React from 'react';
import { Container } from '@pixi/react';
import GameRulesFooter from './gameRulesFooter';
import { isMobile } from '../../../../core/helpers/isMobile';

function GameRulesWrapper({ GameRulesContent, x, y }) {
  return (
    <Container name='GameRulesWrapper' x={x} y={y}>
      <GameRulesContent />
      <GameRulesFooter x={isMobile() ? 261 : 594} y={isMobile() ? 765 : 650} />
    </Container>
  );
}

export default GameRulesWrapper;
